import http from "../http-common";

class BudgetUnitService {
  getAll() {
    return http.get('/budget-units');
  }

  create(data) {
    return http.post('/budget-units', data);
  }

  update(id, data) {
    return http.put(`/budget-units/${id}`, data);
  }

  delete(id) {
    return http.delete(`/budget-units/${id}`);
  }
}

export default new BudgetUnitService();

